import { c as _c } from "react/compiler-runtime";
import { Box, Button, Flex, Text } from '@chakra-ui/react';

/**
 * A single selectable row in a filter dropdown: a ghost button with a small
 * check box and a label. Shared by the network browser's owner/type filters
 * and the assistant chat author filter, which all render byte-identical rows.
 */
function FilterCheckboxOption(t0) {
  const $ = _c(15);
  const {
    label,
    checked,
    onSelect
  } = t0;
  const t1 = checked ? "blue.50" : undefined;
  const t2 = checked ? "blue.500" : "gray.300";
  const t3 = checked ? "blue.500" : "transparent";
  const t4 = checked ? "\u2713" : "";
  let t5;
  if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4) {
    t5 = <Box alignItems="center" borderColor={t2} borderRadius="sm" borderWidth="1px" color={t3} display="flex" fontSize="10px" height="14px" justifyContent="center" width="14px">{t4}</Box>;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = checked ? "blue.800" : "gray.800";
  let t7;
  if ($[4] !== label || $[5] !== t6) {
    t7 = <Text color={t6} fontSize="sm" lineClamp={1}>{label}</Text>;
    $[4] = label;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t5 || $[8] !== t7) {
    t8 = <Flex alignItems="center" gap={2} width="100%">{t5}{t7}</Flex>;
    $[7] = t5;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== checked || $[11] !== onSelect || $[12] !== t1 || $[13] !== t8) {
    t9 = <Button aria-pressed={checked} bg={t1} borderRadius="md" height="auto" justifyContent="flex-start" px={2} py={1.5} size="sm" variant="ghost" onClick={onSelect}>{t8}</Button>;
    $[10] = checked;
    $[11] = onSelect;
    $[12] = t1;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}
export default FilterCheckboxOption;